function nl_fn_dialog() {
    var bg = $("#bgd");
    var body = $("body");

    $(document).on("click", "#bgd, .part-dialog .icon-close, [data-dialog-close]", function (e) {
        e.preventDefault();
        body.removeClass("no-scroll-device");
        bg.fadeOut(300);
        $(".part-dialog").fadeOut(300);

        setTimeout(function () {
            $(".part-dialog").remove();
        }, 500);
    });
}